export const setActiveCategory = category => dispatch => {
  dispatch({
    type: 'SET_ACTIVE_CATEGORY',
    category
  })
  dispatch({
    type: 'SET_CURRENT_CATEGORY',
    category
  })
}
